import { ApiBase, type ApiRequestConfig } from './apiBase';

export type SuggestionSource = 'mastery' | 'mistake_book' | 'memory';

export interface SuggestionCandidateResponse {
  id: string;
  title: string;
  prompt: string;
  icon: string;
  source: SuggestionSource;
  reason: string | null;
}

export interface MainChatSuggestionsResponse {
  suggestions: SuggestionCandidateResponse[];
  generated_by: 'rule_engine';
  degraded: boolean;
  user_id: string;
}

export class ApiSuggestions extends ApiBase {
  async getMainChatSuggestions(
    params: { mode: 'student' | 'teacher'; limit?: number },
    config?: ApiRequestConfig
  ) {
    return this.client.get<MainChatSuggestionsResponse>('/v1/suggestions/main-chat', {
      params,
      ...config,
    });
  }
}

export const apiSuggestions = new ApiSuggestions();
